export default {"src":"/_next/static/image/public/assets/feature-images/fr/rewrite.e97b4eda61617b0f89cad9291abf2431.svg","height":360,"width":510};